import { defineComponent } from '../c-mp/fun/defineComponent'
import { diedAsInfant } from '../fun/diedAsInfant'
import { getPersonImageUrl } from '../fun/getPersonImageUrl'
import { _ } from '../model/ccc'
import { DATAURI_DEATH_WHITE } from '../model/DATAURI_DEATH_WHITE'
import type { IPerson } from '../model/IPerson'
import { PersonImageSize } from '../model/PersonImageSize'

export enum PortraitSize {
	Small,
	Large,
}

export const PortraitComp = defineComponent<{
	getPerson: () => IPerson
	getFileName?: () => string | undefined
	getSize?: () => PortraitSize
}>('PortraitComp', ({ getPerson, getFileName, getSize }, $) => {
	function getSrcset() {
		const person = getPerson()
		if (diedAsInfant(person)) {
			return DATAURI_DEATH_WHITE + ' 300w'
		}

		const fileName = getFileName?.()
		if (fileName?.startsWith('data:')) {
			return fileName + ' 300w'
		}
		return [
			getPersonImageUrl(person.id, { fileName, size: PersonImageSize._48 }) +
				' 48w',
			getPersonImageUrl(person.id, { fileName, size: PersonImageSize._96 }) +
				' 96w',
			getPersonImageUrl(person.id, { fileName }) + ' 300w',
		].join(', ')
	}

	function getSizes() {
		return getSize?.() === PortraitSize.Large ? `300px` : `48px`
	}

	return (
		<img
			class={() =>
				!getSize || getSize() === PortraitSize.Small
					? _.ccc_portrait_small
					: _.ccc_portrait_large
			}
			srcset={getSrcset}
			sizes={getSizes}
			alt=''
			loading='lazy'
		/>
	)
})
